import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface AddLibraryDialogComponentData {
  title: string;
  initial: string;
}
/**
 * AddLibraryDialogComponent
 * Dialog that prompts user to add name for new library item
 */
@Component({
  selector: 'add-library-dialog',
  templateUrl: './add-library-dialog.component.html',
  styleUrls: ['./add-library-dialog.component.css']
})
export class AddLibraryDialogComponent {
  libraryItemName = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AddLibraryDialogComponentData,
    private dialog: MatDialogRef<AddLibraryDialogComponent>,
  ) {
    if (data.initial) {
      this.libraryItemName = data.initial;
    }
  }

  close() {
    this.dialog.close(this.libraryItemName);
  }

  cancel() {
    this.dialog.close();
  }
}
